import { z } from 'zod';

//
// Defined jobs (wrong place maybe?)
//

// Predefined system jobs
export type AdminJob = { type: 'admin'; identifier: string; name: string; command: string; args: string[] };
export const adminJobs: AdminJob[] = [
  {
    type: 'admin',
    identifier: 'core',
    name: 'Core Log',
    command: 'journalctl',
    args: ['-f', '-n', '500', '-u', 'diploi-core', '--output=cat'],
  },
  { type: 'admin', identifier: 'system', name: 'System Log', command: 'journalctl', args: ['-f', '-n', '500'] },
  { type: 'admin', identifier: 'helm', name: 'Helm status', command: 'core', args: ['helm'] },
  { type: 'admin', identifier: 'core-config', name: 'Core Config', command: 'core', args: ['config'] },
];

export type ClientLogViewJob =
  | AdminJob
  | {
      name: string;
      namespace: string;
      type: 'exec';
      command: string[];
      labelSelector: string;
    }
  | {
      name: string;
      namespace: string;
      type: 'log';
      labelSelector: string;
    };

//
// Core 2 api requests
//

export const core2ApiJobStreamRequestSchema = z.object({
  event: z.string(),
  room: z.string(),
  jobUUID: z.string().min(1),
  data: z.string(),
});

export type Core2ApiJobStreamRequest = z.infer<typeof core2ApiJobStreamRequestSchema>;

//
// Client to api requests
//

// Job start
export const client2ApiJobStartRequestSchema = z.discriminatedUnion('type', [
  z.object({
    deploymentID: z.number().int(),
    type: z.literal('admin'),
    adminLogIdentifier: z.string().min(1),
  }),
  z.object({
    deploymentID: z.number().int(),
    namespace: z.string().min(1),
    type: z.literal('command'),
    pod: z.string().min(1).nullable(),
    container: z.string().min(1).nullable(),
    command: z.array(z.string()),
  }),
  z.object({
    type: z.literal('container'),
    deploymentID: z.number().int(),
    namespace: z.string().min(1),
    pod: z.string().min(1).nullable(),
    container: z.string().min(1).nullable(),
  }),
]);

export type Client2ApiJobStartRequest = z.infer<typeof client2ApiJobStartRequestSchema>;
export type Client2ApiJobStartResponse =
  | { status: 'ok'; jobUUID: string }
  | { status: 'insufficient rights' | 'core not found' | 'pod not found' | 'timeout' | 'job not found' };

// Job end (client => api)
export const client2ApiJobEndRequestSchema = z.object({
  deploymentID: z.number().int(),
  jobUUID: z.string().min(1),
});
export type Client2ApiJobEndRequest = z.infer<typeof client2ApiJobEndRequestSchema>;
export type Client2ApiJobEndResponse = { status: 'ok' | 'insufficient rights' | 'job not found' | 'core not found' | 'timeout' };

// Job heartbeat (client => api)
export const client2ApiJobHeartbeatRequestSchema = z.object({
  deploymentID: z.number().int(),
  jobUUID: z.string().min(1),
});
export type Client2ApiJobHeartbeatRequest = z.infer<typeof client2ApiJobHeartbeatRequestSchema>;
export type Client2ApiJobHeartbeatResponse = { status: 'ok' | 'insufficient rights' | 'job not found' | 'core not found' | 'timeout' };

//
// Api to core requests
//

export type Api2CoreJobStartRequest =
  | {
      type: 'admin';
      jobUUID: string;
      adminLogIdentifier: string;
    }
  | {
      jobUUID: string;
      type: 'command';
      namespace: string;
      pod: string | null;
      container: string | null;
      command: string[];
    }
  | {
      jobUUID: string;
      type: 'container';
      namespace: string;
      pod: string | null;
      container: string | null;
    };
export type Api2CoreJobStartResponse = { status: 'ok'; jobUUID: string } | { status: 'timeout' | 'job not found' | 'pod not found' };
export type Api2CoreJobEndRequest = { jobUUID: string };
export type Api2CoreJobEndResponse = { status: 'ok' | 'job not found' | 'timeout' };
export type Api2CoreJobHeartbeatRequest = { jobUUID: string };
export type Api2CoreJobHeartbeatResponse = { status: 'ok' | 'job not found' | 'timeout' };
